// extracted by mini-css-extract-plugin
export default {"urlInput":"urlInput","ant-input":"ant-input","antInput":"ant-input","ant-input-group-addon":"ant-input-group-addon","antInputGroupAddon":"ant-input-group-addon"};